import { render } from "./productNameForm.vue?vue&type=template&id=1a5080e5"
import script from "./productNameForm.vue?vue&type=script&lang=js"
export * from "./productNameForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__